import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import { SaleDiscount } from '@sales/data/sales/discounts/SaleDiscountData';
import React from 'react'
import SaleDiscountDialog from '../../dialogs/SaleDiscountDialog';
import { SaleDiscountRemovalButton } from '../buttons/SaleDiscountButtons';

export type SaleDiscountActionMenuProps = {
    discount: SaleDiscount
};

const SaleDiscountActionMenu = (props: SaleDiscountActionMenuProps) => {
    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Discount">
                <SaleDiscountDialog.Button discount={props.discount} text='Update' />
                <SaleDiscountRemovalButton discount={props.discount} />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
};

export default SaleDiscountActionMenu;